import { render, staticRenderFns } from "./CustomTagsAI.vue?vue&type=template&id=3529ef22&"
import script from "./CustomTagsAI.vue?vue&type=script&lang=js&"
export * from "./CustomTagsAI.vue?vue&type=script&lang=js&"
import style0 from "./CustomTagsAI.vue?vue&type=style&index=0&id=3529ef22&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports